import React from "react";

export const SheetYearCell = ({ row }) => {
   return (
    <>
        {row.year}
    </>
  );
};